var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategyHeaderGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 776,
    height: 360,
    viewBox: "0 0 776 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9916_49086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 776,
    height: 360,
    fill: "#454A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61 -11.6317L170.61 4.40825L86.4862 -41.6389C80.3066 -45.0214 72.7087 -45.0214 66.5291 -41.6388L-17.5948 4.40827L-17.5948 -11.6316C-17.5948 -20.7612 -12.4749 -29.1935 -4.17222 -33.7381L63.2029 -70.6174C71.4424 -75.1275 81.5729 -75.1275 89.8124 -70.6174L157.188 -33.7382C165.49 -29.1935 170.61 -20.7612 170.61 -11.6317Z",
    stroke: "#5E636E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.141 167.617C109.935 172.109 99.8497 172.129 91.6246 167.668L76.5001 159.467L160.536 113.468C166.763 110.059 170.603 103.735 170.603 96.888L170.603 4.40827L185.484 12.4784C193.84 17.0093 199 25.4696 199 34.6358L199 108.598C199 117.727 193.88 126.16 185.578 130.704L118.141 167.617Z",
    stroke: "#5E636E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8598 167.617C43.0659 172.109 53.1508 172.129 61.3759 167.668L76.5004 159.467L-7.53517 113.468C-13.7622 110.059 -17.6021 103.735 -17.6021 96.888L-17.6021 4.40827L-32.4839 12.4784C-40.8391 17.0093 -45.9999 25.4696 -45.9999 34.6358L-45.9999 108.598C-45.9999 117.727 -40.88 126.16 -32.5773 130.704L34.8598 167.617Z",
    stroke: "#5E636E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.503 39.7528L635.503 64.8929L503.652 -7.27886C493.966 -12.5805 482.058 -12.5805 472.372 -7.27886L340.521 64.893L340.521 39.7529C340.521 25.4437 348.545 12.2273 361.559 5.1043L467.159 -52.6984C480.073 -59.7672 495.951 -59.7672 508.865 -52.6984L614.465 5.10428C627.478 12.2273 635.503 25.4437 635.503 39.7528Z",
    stroke: "#5E636E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.266 320.698C540.404 327.739 524.597 327.769 511.706 320.778L488 307.923L619.713 235.827C629.473 230.485 635.491 220.573 635.491 209.841L635.491 64.8929L658.816 77.5417C671.912 84.6431 680.001 97.9034 680.001 112.27L680.001 228.194C680.001 242.503 671.976 255.72 658.963 262.843L553.266 320.698Z",
    stroke: "#5E636E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.735 320.698C435.597 327.739 451.404 327.769 464.295 320.778L488.001 307.923L356.288 235.827C346.528 230.485 340.509 220.573 340.509 209.841L340.509 64.893L317.184 77.5417C304.089 84.6431 296 97.9034 296 112.27L296 228.194C296 242.503 304.025 255.72 317.038 262.843L422.735 320.698Z",
    stroke: "#5E636E",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9916_49086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 776,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyHeaderGrey);
export default __webpack_public_path__ + "static/media/strategyHeaderGrey.1be63dd067954a1d15ebd8516a81279b.svg";
export { ForwardRef as ReactComponent };